export default __webpack_public_path__ + "static/media/DtVkJx26TKEr37c9aBBxOloc_SjTjQJElti5.93b74222.woff2";